module.exports = "../../app/cells/components/practice_test_banner_cell.rb";